import * as CONSTS from 'redux/constants';

const initialState = {
  selectedType: '',
  selectedCategory: null,
  selectedCurrency: null,
  requiredFields: {},
  selectedBankPaymentMethod: '',
  isAddPaymentMethodMode: false,
  getPMTByBinIsLoading: false
};

const paymentSettingsReducer = (state = initialState, { type, payload }) =>
  ({
    [CONSTS.SET_SELECTED_CURRENCY]: { ...state, selectedCurrency: payload },
    [CONSTS.SET_SELECTED_PAYMENT_METHOD_TYPE]: { ...state, selectedType: payload },
    [CONSTS.SET_SELECTED_CATEGORY]: { ...state, selectedCategory: payload },
    [CONSTS.SET_REQUIRED_FIELDS]: { ...state, requiredFields: payload },
    [CONSTS.CLEAR_REQUIRED_FIELDS]: { ...state, requiredFields: {} },
    [CONSTS.SET_SELECTED_BANK_PAYMENT_METHOD]: {
      ...state,
      selectedBankPaymentMethod: payload
    },
    [CONSTS.SET_ADD_PAYMENT_METHOD_MODE]: {
      ...state,
      isAddPaymentMethodMode: payload
    },
    [CONSTS.GET_PMT_BY_BIN_START]: {
      ...state,
      getPMTByBinIsLoading: true
    },
    [CONSTS.GET_PMT_BY_BIN_SUCCESS]: {
      ...state,
      selectedType: payload,
      getPMTByBinIsLoading: false
    },
    [CONSTS.GET_PMT_BY_BIN_FAIL]: {
      ...state,
      selectedType: '',
      getPMTByBinIsLoading: false
    }
  }[type] || state);

export default paymentSettingsReducer;
